var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9428 5.00834C11.1269 5.52905 10.854 6.10037 10.3332 6.28442C8.38991 6.97129 7 8.8247 7 11.0002V17.0002C7 17.3507 6.93987 17.6873 6.82935 18H17.1706C17.0601 17.6873 17 17.3507 17 17.0002V14.0002C17 13.4479 17.4477 13.0002 18 13.0002C18.5523 13.0002 19 13.4479 19 14.0002V17.0002C19 17.5462 19.4377 17.9901 19.9814 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20.0002 20 20.0002L19.9678 20H14C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20H4.03225L4 20.0002C3.44772 20.0002 3 19.5525 3 19.0002C3 18.4479 3.44772 18 4 18H4.01861C4.56231 17.9901 5 17.5462 5 17.0002V11.0002C5 7.95076 6.94932 5.35922 9.66675 4.39874C10.1875 4.21469 10.7588 4.48762 10.9428 5.00834Z",
    fill: "#747B80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 4,
    fill: "#FF6F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/NotificationActive.0e26485bdd099c5d8c54c46e281fbe18.svg";
export { ForwardRef as ReactComponent };